//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';

export default {
    name: 'Currency',
    data() {
        return {
            interest: '',
            rate: '',
            name: '',
            active: '',
        };
    },
    computed: {
        ...mapGetters(['currency', 'currencies', 'step']),
    },
    methods: {
        ...mapMutations([
            'setCurrency', 'setCurrencies',
        ]),
        selectCurrency(currency) {
            this.$store.dispatch('setCurrency', currency);
            this.setCurrency(currency);
        },
        setCurrency(currency) {
            this.interest = currency.currencyRate.interest.toLocaleString('de-DE', {minimumFractionDigits: 4}) + '%';
            this.rate = currency.currencyRate.rate.toLocaleString('de-DE', {minimumFractionDigits: 4}) + ' ' + currency.code;
            this.name = currency.name;
            this.active = currency.active;
        },
        onSubmit(){
            if (this.isComplete()) {
                this.$store.dispatch('setStep', this.step + 1);
            }
        },
        isFlat(element) {
            return this.name !== element.name;
        },
        isComplete() {
            if(this.interest && this.name && this.rate && this.active){
                return true;
            }
            return false;
        },
    },
    mounted() {
        if(Object.keys(this.currency).length) {
            this.setCurrency(this.currency);
        }
    },
};
